import { _ as __assign } from './chunks/bundle-j5GfJ6DZ.js';
import { u as useSendbird } from './chunks/bundle-DloqDvm2.js';
import './chunks/bundle-BC1GKYVu.js';
import 'react';
import './chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';

// NOTE: Do not use this hook internally.
// This hook is exported to support backward compatibility.
// Keep this function for backward compatibility.
function useSendbirdStateContext() {
    var _a = useSendbird(), state = _a.state, actions = _a.actions;
    return __assign(__assign({}, state), actions);
}

export { useSendbirdStateContext as default, useSendbirdStateContext };
//# sourceMappingURL=useSendbirdStateContext.js.map
